//#region Components
import SimpleTableList from "../SimpleTableList/SimpleTableList";
import StudentTableListItem from "../StudentTableListItem/StudentTableListItem";
import StudentTableListResponsableItem from "../StudentTableListItem/StudentTableListResponsableItem";
//#endregion
//#region Utils
import { HEADER_TABLE_LIST } from "../../utils/constants";
//#endregion

const StudentTableList = ({
    data,
    studentsSelected,
    getInfoTooltipOfPenalize,
    formList
}) => {
    return (
        <SimpleTableList 
            headers={HEADER_TABLE_LIST}
            maxHeight="25vh"
            content={
                <>
                <StudentTableListResponsableItem studentsSelected={studentsSelected}/>
                {data.map((dataItem, idx) => (
                    <StudentTableListItem 
                        key={idx}
                        data={dataItem}
                        isResponsable={idx === 0}
                        studentsSelected={studentsSelected}
                        getInfoTooltipOfPenalize={getInfoTooltipOfPenalize}
                        formList={formList}/>
                ))}
                </>
            }/>
    );
}

export default StudentTableList